import { AuditResearchDirectoryList } from "./AuditResearchDirectoryList";

export default {
  list: AuditResearchDirectoryList,
  recordRepresentation: "name",
};
